import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button, Row, Col, Dropdown } from "react-bootstrap";
import { gameCoin } from "actions/gameCoin";
import { setWallet } from "actions/gameWallet";
import storage from "utils/Storage";
import C from 'utils/Constant';
import { RiFileCopyFill } from "react-icons/ri";

import { Event, __, wait, isValidNumber, forceSatoshiFormat, sendNotfication } from 'utils/Helper';
import { userUID } from 'utils/AuthHelper';
import "./ManualBet.css";
import styled from "styled-components";

const StyledWrapper = styled.div`
  .switch {
    position: relative;
    height: 1.2rem;
    width: 2rem;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    border-radius: 9999px;
    background-color: rgba(100, 116, 139, 0.377);
    transition: all 0.3s ease;
    display: block;
    margin-left: 0.5rem;
  }

  .switch:checked {
    background-color: rgba(93, 160, 0, 0.2);
  }

  .switch::before {
    position: absolute;
    content: "";
    left: calc(0.1rem);
    top: calc(0.1rem);
    display: block;
    height: 1rem;
    width: 1rem;
    cursor: pointer;
    border: 1px solid rgba(100, 116, 139, 0.527);
    border-radius: 50%;
    background-color: #707782;
    box-shadow: 0 3px 10px rgba(100, 116, 139, 0.327);
    transition: all 0.3s ease;
  }

  .switch:hover::before {
    box-shadow: 0 0 0px 8px rgba(0, 0, 0, 0.15);
  }

  .switch:checked:hover::before {
    box-shadow: 0 0 0px 8px rgba(93, 160, 0, 0.2);
  }

  .switch:checked::before {
    transform: translateX(100%);
    border-color: rgba(93, 160, 0, 0.2);
    background-color: #43b309; /* Changes to green when checked */
  }
`;
const CrashMainDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

const CrashTable = styled.div`
  background-color: rgb(30, 32, 36);
  margin-left: 0.625rem;
  border-radius: 1.25rem;
  width: 40%;
  max-width: 542px;
  position: relative;
`;

const CrashTableTop = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  position: absolute;
  top: -1.875rem;
  left: 0px;
  right: 0px;
  padding: 0px 0.625rem;
  line-height: 1.25rem;
`;

const CrashTableTitle = styled.div`
  font-weight: bold;
  color: rgb(245, 246, 247);
`;

const CrashTableFlex = styled.div`
  display: flex;
  align-items: center;
`;
class ManualBet extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      engine: this.props.engine,
      buttonText: "BET",
      buttonType: "",
      playing: false,
      inputDisabled: false,
      risk: "low",
      buttonProgress: false,
      numbers: [],
      bitError: false,
      outError: false,
      lock: false,
      holding: false,
      amount: forceSatoshiFormat(
        storage.getKey("lam") ? storage.getKey("lam") : 0.0000001
      ),
      isLogged: storage.getKey("logged") !== null ? true : false,
      coin: storage.getKey("coin"),
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleRisk = this.handleRisk.bind(this);
    this.handleBet = this.handleBet.bind(this);
    this.clearTable = this.clearTable.bind(this);
    this.autoPick = this.autoPick.bind(this);
  }

  componentDidMount() {
    let { engine } = this.state;
    this._isMounted = true;

    //Set Coin for Redux
    this.props.gameCoin();

    engine.on(C.STATUS_KENO, (data) => this.checkStatus(data));
    engine.on(C.WAITING_KENO, () => this.checkWaitingGame());
    engine.on(C.BUSTED_KENO, () => this.checkBustedGame());
    engine.on(C.STARTED_KENO, () => this.checkStartedGame());
    engine.on(C.PLAY_KENO, (data) => this.handlePlay(data));
    engine.on(C.KENO_AMOUNT, (data) => this.amount(data));
    engine.on(C.ERROR_KENO, (data) => this.handleError(data));
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleError(data) {
    if (this._isMounted) {
      sendNotfication(data.message, "info", "top-center");

      this.setState({ holding: false, look: false, playing: false });

      if (data.code === "credit") this.props.setWallet(true, data.uid);

      this.setDefaultButton();
    }
  }

  handleRisk(e) {
    this.setState({ risk: e });
  }

  handleInputChange(event) {
    let target = event.target;
    let value = target.value;
    let name = target.name;

    if (__.isEmpty(value)) {
      if (name === "amount") this.setState({ amount: value });
      this.setState({ bitError: "red-border" });

      if (name === "risk") this.setState({ outError: "red-border" });
    } else {
      if (name === "amount") this.setState({ bitError: false });

      if (name === "risk") this.setState({ outError: false });
    }

    if (!isValidNumber(value)) return;

    if (name === "amount") {
      storage.setKey("lam", value);
    }

    this.setState({ [name]: value });
  }

  setDefaultButton() {
    if (this._isMounted) {
      this.setState({
        inputDisabled: false,
        buttonType: "",
        buttonText: "BET",
      });
    }
  }

  setDisabledButton() {
    if (this._isMounted) {
      this.setState({
        inputDisabled: true,
        buttonType: "",
        buttonText: "BET",
      });
    }
  }

  setOutButton() {
    if (this._isMounted) {
      this.setState({
        inputDisabled: true,
        buttonType: "btn-success",
        buttonText: "CANCEL",
      });
    }
  }

  handlePlay = (data) => {
    if (this._isMounted) {
      if (parseFloat(data.uid) === parseFloat(userUID()))
        this.setState({ playing: true });
    }
  };

  checkWaitingGame() {
    if (this._isMounted) {
      if (this.state.holding === true) {
        this.setState({ holding: false });
        this.placeBet();
      }

      for (var i = 0; i < 41; i++) {
        if (document.getElementById("b_" + i) !== null)
          document.getElementById("b_" + i).classList.remove("alerts");
      }
    }
  }

  checkStartedGame() {
    if (this._isMounted) {
      if (this.state.lock === true || this.state.playing === true) {
        this.setState({ lock: false });
        this.setDisabledButton();
      }
    }
  }

  checkBustedGame = () => {
    if (this._isMounted) {
      let { engine } = this.state;

      if (this.state.holding === false) {
        engine.init = false;
        clearInterval(this.state.buttonProgress);
        this.setState({ playing: false });
        this.setDefaultButton();
      }
    }
  };

  checkStatus(data) {
    if (this._isMounted) {
      switch (data.status) {
        case "waiting_keno":
          this.checkWaitingGame();
          break;
        case "started_keno":
          this.checkStartedGame();
          break;
        case "busted_keno":
          this.checkBustedGame();
          break;
        default:
      }
    }
  }

  isCorrectBet(amount) {
    if (amount === 0) return false;

    if (!isValidNumber(amount)) return false;

    return true;
  }

  placeBet() {
    if (this._isMounted) {
      let { engine } = this.state;

      // Disable For double queue or network delay
      if (this.state.lock === true) return;

      this.setState({
        lock: true,
        playing: true,
        inputDisabled: true,
        buttonType: "btn-secondary",
        buttonText: "Please Wait...",
      });

      wait(10).then(() => {
        engine.init = true;
        engine.coin = this.props.coin;
        engine.numbers = this.state.numbers;
        engine.amount =
          forceSatoshiFormat(this.state.amount) * this.state.numbers.length;
        engine.force();
      });
    }
  }

  holdBet() {
    if (this._isMounted) {
      if (this.state.holding === true) {
        this.setDefaultButton();
        this.setState({ holding: false });
      } else {
        this.setOutButton();
        this.setState({ holding: true });
      }
    }
  }

  handleBet(e) {
    if (this._isMounted) {
      e.preventDefault();

      let { amount } = this.state;

      // Check User
      if (!this.state.isLogged) {
        return Event.emit("showAuthModal", true);
      }

      if (this.state.numbers.length < 3) {
        return sendNotfication(
          "Please select at least 3 number",
          "info",
          "top-center"
        );
      }

      // Check is Correct Bet
      if (!this.isCorrectBet(this.state.amount)) return false;

      // Check for Double request
      if (this.state.lock === true) return false;

      if (parseFloat(amount) <= 0) {
        this.setState({ amount: forceSatoshiFormat(0.0000001) });
      } else {
        amount = Math.min(
          parseFloat(storage.getKey("credit")),
          parseFloat(amount)
        );
        this.setState({ amount: forceSatoshiFormat(amount) });
      }

      // Check Game Status to Play
      switch (this.state.engine.gameStatus) {
        case "waiting_keno":
          this.placeBet();
          break;

        case "started_keno":
          this.holdBet();
          break;

        case "busted_keno":
          this.holdBet();
          break;

        default:
      }
    }
  }

  selectNum(num) {
    if (this._isMounted) {
      if (!this.state.numbers.includes(num)) {
        if (this.state.numbers.length < 10)
          this.setState((state) => ({ numbers: [num, ...state.numbers] }));
      } else {
        const remove = (num) => {
          return __.without(this.state.numbers, num);
        };
        this.setState(() => ({ numbers: remove(num) }));
      }
    }
  }

  clearTable() {
    if (this._isMounted) {
      this.setState({ numbers: [] });
    }
  }

  autoPick() {
    if (this._isMounted) {
      this.clearTable();
      wait(getRandomInt(1, 150)).then(() => {
        for (var i = 0; i < 19; i++) {
          let num = getRandomInt(1, 40);
          if (!this.state.numbers.includes(num)) {
            if (this.state.numbers.length !== 10) {
              this.setState((state) => ({ numbers: [num, ...state.numbers] }));
            }
          }
        }
      });
    }
  }

  amount(data) {
    if (this._isMounted) {
      data.amount.forEach((c, i) => {
        var amount = c;
        if (document.getElementById("b_" + amount) !== null) {
          wait(amount * 50).then(() => {
            if (document.getElementById("b_" + amount) !== null)
              document.getElementById("b_" + amount).classList.add("alerts");
          });
        }
      });
    }
  }

  render() {
    const makeNumber = (num) => {
      let disabled = false;

      if (this.state.lock === true || this.state.playing === true) {
        disabled = true;
      }

      let active = false;

      if (this.state.numbers.includes(num)) {
        active = "active";
      }

      let button = React.createElement(
        "button",
        {
          type: "button",
          id: "b_" + num,
          disabled: disabled,
          className: "btn btn-soft-secondary btn-xl btn-block " + active,
          onClick: () => this.selectNum(num),
          style: { backgroundColor: "#31343C" },
        },
        num
      );

      return React.createElement("div", { className: "keno-numbers" }, button);
    };

    const generateNumber = () => {
      let make = [];
      for (var i = 1; i < 41; i++) {
        make[i] = makeNumber(i);
      }
      return make;
    };

    let {
      inputDisabled,
      risk,
      numbers,
      buttonType,
      bitError,
      buttonText,
      amount,
    } = this.state;

    return (
      <>
        <form
          style={{
            width: "100%",
            backgroundColor: "#24262B",
            height: "auto",
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
          }}
          className="w-100"
          onSubmit={(e) => {
            e.preventDefault();
            if (this.props.coin === "INR") {
              if (this.state.amount < 20) {
                sendNotfication("Enter valid amount");
              } else {
                this.handleBet(e);
              }
            } else if (this.props.coin === "USDT") {
              if (this.state.amount < 0.5) {
                sendNotfication("Enter valid amount");
              } else {
                this.handleBet(e);
              }
            } else {
              this.handleBet(e);
            }
          }}
        >
          {/* Main game  */}
          <div
            className="col-md-12 col-xl-8"
            style={{
              backgroundColor: "#17181B",
              // width: "60%",
              padding: "20px",
              // borderRadius: "10px",
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
            }}
          >
            <div style={{ whiteSpace: "nowrap" }} className="grid-buttons">
              {generateNumber()}
            </div>
            <svg
              style={{ marginTop: "30px" }}
              class="box-bg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 996 46"
            >
              <defs>
                <linearGradient
                  id="gcardBg"
                  x1="50%"
                  x2="50%"
                  y1="0%"
                  y2="100%"
                >
                  <stop offset="0%" stop-color="#31343C"></stop>
                  <stop
                    offset="100%"
                    stop-color="#1E2024"
                    stop-opacity="0"
                  ></stop>
                </linearGradient>
              </defs>
              <g opacity=".899">
                <path
                  fill="url(#gcardBg)"
                  fill-rule="evenodd"
                  d="M0 0h996L892 46H96z"
                  opacity=".598"
                  transform="rotate(-180 498 23)"
                ></path>
              </g>
            </svg>
            <div
              style={{ display: "flex", gap: "60px" }}
              className="main-bet-sec"
            >
              <div
                className={
                  "crash-manual-bat-main-label  btn-group-toggle 'tcr "
                }
                data-toggle="buttons"
              >
                <label className="btn  active border-green">
                  <input type="radio" /> Manual
                </label>
                
              </div>
              <div style={{ marginTop: "40px" }} className="allsecau">
                <Row>
                  <Col sm={12} lg={8} className={"m-auto"}>
                    <div className={"form-group rev mb-1"}>
                      <Button
                        style={{
                          // border: "2px solid red",
                          color: "#fff",
                          boxShadow:
                            "0px 0px 12px rgba(35, 238, 136, 0.3), 0px -2px rgb(29, 202, 106) inset",

                          // backgroundColor: "rgb(67, 179, 9)",
                          backgroundImage:
                            "linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113))",
                          borderRadius: "10px",
                        }}
                        variant={
                          "btn btn-sm btn-block mt-2 btn-bet " + buttonType
                        }
                        disabled={inputDisabled}
                        type="submit"
                      >
                        {buttonText}
                      </Button>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} sm={12} className={"mt-3"}>
                    <div className={"form-group bet-input mb-2 " + bitError}>
                      <div
                        style={{
                          borderRadius: "20px",
                          overflow: "hidden", // Ensures child elements respect the parent's border radius
                        }}
                        className="input-group"
                      >
                        <div className="input-group-append">
                          <span
                            style={{
                              backgroundColor: "#31343c",
                              borderRadius: "0", // Remove individual radius
                              border: "none", // Remove default borders
                              fontFamily: "arial",
                            }}
                            className="input-group-text"
                          >
                            BET
                          </span>
                        </div>
                        <input
                          style={{
                            backgroundColor: "#222328",
                            borderRadius: "0", // Remove individual radius
                            border: "none", // Remove default borders
                          }}
                          disabled={inputDisabled}
                          type="text"
                          className="form-control text-left"
                          id="amount"
                          name="amount"
                          max="900000000"
                          placeholder="Enter Bet Amount"
                          value={amount}
                          autoComplete={"off"}
                          required={true}
                          onKeyUp={this.handleInputChange}
                          onChange={this.handleInputChange}
                        />
                        <div className="input-group-append">
                          <span
                            style={{
                              backgroundColor: "#31343c",
                              borderRadius: "0",
                              border: "none",
                              fontFamily: "arial",
                            }}
                            className="input-group-text"
                          >
                            {this.props.coin}
                          </span>
                        </div>
                        <div className="input-group-append">
                          <span
                            style={{
                              backgroundColor: "#31343c",
                              borderRadius: "0",
                              border: "none",
                            }}
                            className="input-group-text text-lowercase"
                          >
                            x
                          </span>
                        </div>
                        <div className="input-group-append">
                          <span
                            style={{
                              backgroundColor: "#31343c",
                              borderRadius: "0",
                              border: "none",
                            }}
                            className="input-group-text text-lowercase"
                          >
                            {numbers.length}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <span
                        style={{
                          fontFamily: "arial",
                          fontSize: 11,
                          marginLeft: 5,
                        }}
                      >
                        {this.props.coin === "INR"
                          ? "(Minimum Bet - 20 INR)"
                          : "(Minimum Bet - 0.5 USDT)"}
                      </span>
                    </div>
                  </Col>
                  <Col lg={5} sm={12} className={"mt-3"}>
                    <div className={"form-group mb-0 " + bitError}>
                      <div className="input-group fw">
                        <div
                          style={{
                            overflow: "hidden",
                            borderTopLeftRadius: "20px",
                            borderBottomLeftRadius: "20px",
                            backgroundColor: "#31343c",
                          }}
                          className="input-group-append col-sm-10"
                        >
                          <span
                            style={{
                              backgroundColor: "#31343c",
                              color: "#636264",
                            }}
                            className="input-group-text"
                          >
                            RISK
                          </span>
                        </div>
                        <Dropdown
                          style={{
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            width: "200px",
                            backgroundColor: "#31343c",
                          }}
                          className={"drop-select btn-block"}
                        >
                          <Dropdown.Toggle
                            split
                            variant=""
                            className={"py-0 mt-0"}
                          >
                            <span className="text-muted text-center">
                              {risk}
                              <i
                                className={
                                  "mdi mdi-chevron-down mr-1 ccol chera"
                                }
                              />
                            </span>
                          </Dropdown.Toggle>
                          <Dropdown.Menu
                            disabled={inputDisabled}
                            className={"dopdown-menu-bottom " + inputDisabled}
                          >
                            <Dropdown.Item
                              onClick={(e) => this.handleRisk("low")}
                              className={"animated fadeIn"}
                            >
                              Low
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={(e) => this.handleRisk("medium")}
                              className={"animated fadeIn"}
                            >
                              Medium
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={(e) => this.handleRisk("high")}
                              className={"animated fadeIn"}
                            >
                              High
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </Col>
                </Row>
                {/* Auto bet and clear bet button */}
                <Row className="mainautosec">
                  <Col
                    md={12}
                    sm={12}
                    lg={6}
                    style={{
                      display: "flex",
                      backgroundColor: "#222328",
                      borderRadius: "20px",
                      alignItems: "center",
                      padding: "10px",
                      flex: 2,
                    }}
                  >
                    <div
                      style={{
                        overflowX: "scroll",
                        whiteSpace: "nowrap",
                        flex: "1",
                        marginRight: "10px",
                        display: "flex",
                        alignItems: "center",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                      }}
                    >
                      <p
                        style={{
                          margin: "0",
                          color: "#fff",
                        }}
                      >
                        4ddb475a1f941e619b1d24ce4b776ebaca44b51d5185b4378a96b9e03a5c7b01
                      </p>
                    </div>
                    <div
                      style={{
                        backgroundColor: "#000",
                        borderRadius: "5px",
                        padding: "5px",
                      }}
                    >
                      <RiFileCopyFill style={{ color: "#fff" }} />
                    </div>
                  </Col>

                  <Col md={12} sm={12} style={{ flex: 1, padding: "0 5px" }}>
                    <button
                      style={{
                        borderRadius: "2rem",
                        backgroundColor: "#6B7180",
                        color: "white",
                        width: "100%",
                        height: "5vh",
                      }}
                      type="button"
                      className="btn btn-outline-light btn-block btn-xs"
                      disabled={inputDisabled}
                      onClick={this.autoPick}
                    >
                      Auto Pick
                    </button>
                  </Col>
                  <Col md={12} sm={12} style={{ flex: 1, padding: "0 5px" }}>
                    <button
                      style={{
                        borderRadius: "2rem",
                        backgroundColor: "#6B7180",
                        color: "white",
                        width: "100%",
                        height: "5vh",
                      }}
                      type="button"
                      className="btn btn-outline-light btn-block btn-xs"
                      disabled={inputDisabled}
                      onClick={this.clearTable}
                    >
                      Clear Table
                    </button>
                  </Col>
                </Row>
                <div
                  className="mines-option game-fonts"
                  style={{
                    display: "flex",
                    width: "100%",
                    // display:"none",
                    justifyContent: "space-around",
                    padding: "2px 5px",
                    textAlign: "center",
                    alignItems: "center",
                    justifyItems: "center",
                    margin: "0px 0px",
                    borderTop: "1px solid #222328",
                  }}
                >
                  {/* Manual */}
                  <div
                    style={{ fontFamily: "arial" }}
                    className={`mines-manual-button`}
                  >
                    Manual
                  </div>

                  {/* Auto */}
                  <div
                    style={{ fontFamily: "arial" }}
                    className={`mines-auto-button`}
                  >
                    Auto
                  </div>
                </div>

                {/* Minimun bet text */}

                {/* All other bet */}
              </div>
            </div>
          </div>

         
        </form>
      </>
    );
  }
}

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

ManualBet.propTypes = {
  coin: PropTypes.string,
};

const mapStateToProps = (state) => ({
  coin: state.items.coin,
});

export default connect(mapStateToProps, { gameCoin, setWallet })(ManualBet);
